<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import CompanyProfile from '~src/components/account/CompanyProfile'

    @Component({
        mixins: [CompanyProfile],
    })
    export class SupplierProfile extends Vue {
        types = ['INTERNAL_SUPPLIER', 'HUB_SUPPLIER']

        mounted() {
            if (!this.company?.id) {
                this.types = ['INTERNAL_SUPPLIER']
                this.company.type = 'INTERNAL_SUPPLIER'
            }
        }

        get dontAllowEdit() {
            return this.company?.type === 'HUB_SUPPLIER'
        }
    }

    export default {...toNative(SupplierProfile), ssrRender: CompanyProfile.ssrRender}
</script>
